import { render, staticRenderFns } from "./surveItem2.vue?vue&type=template&id=659b5d22&scoped=true"
import script from "./surveItem2.vue?vue&type=script&lang=js"
export * from "./surveItem2.vue?vue&type=script&lang=js"
import style1 from "./surveItem2.vue?vue&type=style&index=1&id=659b5d22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659b5d22",
  null
  
)

export default component.exports